import api from '../../api'

export default {
    async fetchCoupons({ commit, state }, { search, sortKey, sortType, pageSize, page }) {
        var data = await api.coupon.fetchCoupons(
            search && search.trim() != '' ? search : null,
            sortKey || null,
            sortType || null,
            pageSize,
            page
        )
        commit('SET_COUPONS', data.data)
        commit('SET_COUPONS_SUMMARY', { ...data, data: null })
    },
    async fetchCouponSummary({ commit, state }, { search }) {
        var data = await api.coupon.fetchCouponSummary(
            search && search.trim() != '' ? search : null
        )
        // commit('SET_ORGANISATIONS', data)
    }
}
